<div class="company-cbp-assigned-number-request-page">
  <div class="container page-container">
    <div class="row flex-wrap-reverse">
      <div class="col-12 col-lg-8 company-cbp-assigned-number-request-page__left-block">
        <div class="company-cbp-assigned-number-request-page__left-container">
          <router-outlet></router-outlet>
          <div class="company-cbp-assigned-number-request-page__navigation-buttons">
            <button type="button" class="btn btn-outline-bordered btn-square d-flex align-items-center" (click)="navigateBackToCompany()">
              <img class="cheveron-icon flip-x" src="/assets/icons/icon_chevron_right.svg" alt="left chev" />
              {{ "BUTTON.BACK_NO_CBP_NUMBER_NEEDED" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-square d-flex align-items-center"
              [disabled]="isContinueDisabled || isSending"
              (click)="isShowSendButton ? send() : continue()"
            >
              {{ (isShowSendButton ? "BUTTON.SEND" : "BUTTON.CONTINUE") | translate }}
              <img *ngIf="!isShowSendButton" class="arrow-icon" src="/assets/icons/icon_arrow_right_sm_white.svg" alt="left chev" />
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4 d-lg-block company-cbp-assigned-number-request-page__right-block">
        <div class="company-cbp-assigned-number-request-page__right-container">
          <app-payment-breakdown [notes]="paymentBreakdownNotes" [pendingBills]="pendingBills"></app-payment-breakdown>
          <loading-spinner [show]="isLoadingBills"></loading-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
